import * as angular from 'angular';

import { ComponentDefinition, ITrackableViewModel } from '../../models';

class ContextualTitleController implements angular.IComponentController {
    readonly titleText: string;
    readonly trackable: ITrackableViewModel;

    static $inject = [];

}

export const wtContextualTitle: ComponentDefinition = {
    componentId: 'wtContextualTitle',
    controller: ContextualTitleController,
    controllerAs: 'vm',
    template: require('./contextualTitle.component.html'),
    transclude: true,
    bindings: {
        titleText: '<',
        trackable: '<?'
    }
};